(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xvxii-925-clean-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      const videos = scope.querySelectorAll('video');
      if (videos.length && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting ? entry.target.play().catch(() => {}) : entry.target.pause()), { threshold: .18 });
        videos.forEach((video) => observer.observe(video));
      }

      const polaroids = scope.querySelectorAll('.x925lux__polaroid');
      const setActive = (selected) => polaroids.forEach((photo) => {
        const active = photo === selected && !photo.classList.contains('is-active');
        photo.classList.toggle('is-active', active);
        photo.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      polaroids.forEach((photo) => {
        if (photo.dataset.x925Bound === 'true') return;
        photo.dataset.x925Bound = 'true';
        photo.addEventListener('click', () => setActive(photo));
        photo.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setActive(photo);
          } else if (event.key === 'Escape') {
            photo.classList.remove('is-active');
            photo.setAttribute('aria-pressed', 'false');
          }
        });
      });
    };
    document.querySelectorAll('[data-x925-clean-home]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => { const scope = event.target.querySelector('[data-x925-clean-home]'); if (scope) initialise(scope); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xvxii-925-collection-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      const sort = scope.querySelector('[data-x925-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          window.location.assign(url.toString());
        });
      }
      const videos = scope.querySelectorAll('.x925c__motion-video');
      if (!videos.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play().catch(() => {});
          else entry.target.pause();
        });
      }, { threshold: 0.2 });
      videos.forEach((video) => observer.observe(video));
    };
    document.querySelectorAll('[data-x925-collection]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target.querySelector('[data-x925-collection]');
      if (scope) initialise(scope);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xvxii-925-home-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseVideoPlayback = (scope) => {
      const videos = scope.querySelectorAll('.x925v2__motion-video');
      if (!videos.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.2 });
      videos.forEach((video) => observer.observe(video));
    };

    document.querySelectorAll('[data-x925-premium-home]').forEach(initialiseVideoPlayback);
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target.querySelector('[data-x925-premium-home]');
      if (scope) initialiseVideoPlayback(scope);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xvxii-925-product-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      const form = scope.querySelector('[data-product-form]');
      const price = scope.querySelector('[data-x925-price]');
      const compare = scope.querySelector('[data-x925-compare]');
      const button = scope.querySelector('[data-x925-add]');
      const buttonLabel = scope.querySelector('[data-x925-add-label]');
      const buttonPrice = scope.querySelector('[data-x925-add-price]');
      const addLabel = buttonLabel ? buttonLabel.textContent.trim() : '';
      const soldOutLabel = scope.querySelector('.x925p__variant-input:disabled + label small')?.textContent.trim() || buttonLabel?.textContent.trim() || '';

      if (form) {
        form.querySelectorAll('.x925p__variant-input').forEach((input) => {
          input.addEventListener('change', () => {
            if (!input.checked) return;
            const available = input.dataset.available === 'true';
            if (price) price.textContent = input.dataset.price || '';
            if (compare) {
              compare.textContent = input.dataset.compare || '';
              compare.classList.toggle('is-hidden', !input.dataset.compare);
            }
            if (button) button.disabled = !available;
            if (buttonLabel) buttonLabel.textContent = available ? addLabel : soldOutLabel;
            if (buttonPrice) buttonPrice.textContent = available ? input.dataset.price || '' : '';
            if (input.dataset.mediaId) {
              const media = Array.from(scope.querySelectorAll('[data-media-id]')).find((item) => item.dataset.mediaId === input.dataset.mediaId);
              if (media && window.matchMedia('(max-width: 989px)').matches) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          });
        });
      }

      const videos = scope.querySelectorAll('.x925p__video');
      if (!videos.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play().catch(() => {});
          else entry.target.pause();
        });
      }, { threshold: 0.2 });
      videos.forEach((video) => observer.observe(video));
    };

    document.querySelectorAll('[data-x925-product]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target.querySelector('[data-x925-product]');
      if (scope) initialise(scope);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
